import React, { useState } from "react";
import { Drawer, Upload } from "antd";
import { useToggle, notifOps, server, usePet } from "../../modules";
import { useHistory, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { AiOutlineInbox } from 'react-icons/ai'
import { useSelector } from "react-redux";


const { Dragger } = Upload
const Attachments = ({handleFiles, onSave, record = {
    uuid: " ",
    label: " ",
    description: " ",
    fileNme: "fileName",
    required: false
} }) => {
    // const [files, setFiles] = useState([])

    const [visible, toggleVisible] = useToggle(true)
    //  const [files, setFiles] = useState(record?.files)
    // const [fileName, setFileName] = useState()
    const [fileList, setFileList] = useState()
    const [uuid, setUuid] = useState(record?.uuid)
    const [label, setLabel] = useState(record?.label)
    const [description, setDescription] = useState(record?.description)
    const [fileNme, setFileNme] = useState(record?.fileNme)
    const [dateAdded, setDateAdded] = useState()
    const [required, setRequired] = useState(true)
    const formData = new FormData()

    const { enqueueSnackbar } = useSnackbar();

    const history = useHistory()
    const { index } = useParams()
    const { params } = useSelector((state) => state.application);
  
    
    const modify = (e) => {
      switch (e.target.name) {

        case "uuid":
          setUuid(e.target.value);
          break;

        case "label":
          setLabel(e.target.value);
          break;

        case "description":
          setDescription(e.target.value);
          break;

        default:
          break;
      }
    };
  
  // console.log(files, " files to go to endpoint.....")
  // const formData = new FormData();

  // if (files) {
  //   console.log("After condition", formData)
  //   console.log("After condition", files);
  //   formData.append("file", files, files.name);
  //    for (let [key, value] of formData.entries()) {
  //      console.log(`${key}:`, value);
  //      console.log(formData.entries(), " entries")
  //    }
  // }
  // const [{ loading }, addAttach] = usePet(
  //   "attachments",
  //   { files },
  //   { notify: true, manual: true }
  // );

  

    const close = () => {
        toggleVisible()
        setTimeout(()=> history.goBack(), 300)
    }

  const save = () => {
     if (fileList && fileList !== undefined) {
        onSave(
          {
            label,
            description,
            fileNme,
          },
          index
        );
        handleFiles(fileList);
        close();
     } else {
       enqueueSnackbar(
        "Please Upload atleast one file",
        notifOps("error")
      );
      }
    }

   const props = {
     name: "passport",
     action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
     fileList: fileList,
     onChange: (file) => {
       let { fileList } = file;
       let isPDF =
         fileList[0]?.type === "application/pdf" ||
         fileList[0]?.type === "image/jpeg" ||
         fileList[0]?.type === "image/jpg" ||
         fileList[0]?.type === "image/png";
       console.log(fileList[0]?.type, " the file type.....");

       let isNotPDF = !isPDF;
       if (isNotPDF) {
         enqueueSnackbar(
           "Please upload either an image or pdf",
           notifOps("warning")
         );
         return false;
       }
       let isLarge =
         fileList[0]?.size / 1024 / 1024 > params?.maxFileUploadSize;
       if (isLarge)
         enqueueSnackbar(
           `Please upload a file smaller than ${params?.maxFileUploadSize} MB`,
           notifOps("warning")
         );

       if (!(isNotPDF || isLarge))
         setFileList(fileList);
         setFileNme(fileList[0]?.name);
     },
     onRemove: (file) => {
       const filt = fileList.filter((itm) => itm.uid !== file.uid);
       setFileList(filt);
     },
     beforeUpload: () => false,
     onDrop: (e) => {
       console.log("Dropped files", e.dataTransfer.files);
     },
   };
  
    return (
      <Drawer
        closable
        maskClosable
        visible={visible}
        onClose={close}
        footer={
          <div className="w-full text-right">
            <button
              onClick={() => {
                save()
              }}
              className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            >
              Save
            </button>
          </div>
        }
        width="40%"
      >
        <p className="font-extrabold text-2xl mb-0">
          {record ? "Edit" : "Add"} Atachment
        </p>
        <div className="w-full px-3 mt-2 mb-1">
          <Dragger {...props}>
            <p className="ant-upload-drag-icon flex justify-center">
              <AiOutlineInbox size={40} />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">
              Please select a pdf or image file (pdf/jpg/jpeg/png)
            </p>
          </Dragger>
        </div>
        <div className="flex flex-wrap mt-3">
          <div className="w-full px-3 mb-1">
            <>
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-name"
              >
                Name
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="grid-name"
                name="name"
                value={fileNme}
                onChange={modify}
                type="text"
                placeholder="Attachment Name"
                disabled={record.required}
              />
            </>
          </div>
          <div className="w-full px-3 mb-1">
            <>
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-name"
              >
                Label
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="grid-label"
                name="label"
                value={label}
                onChange={modify}
                type="text"
                placeholder="Label"
                disabled={record.required}
              />
            </>
          </div>
          <div className="w-full px-3 mb-1">
            <>
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-name"
              >
                Description
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="grid-description"
                name="description"
                value={description}
                onChange={modify}
                type="text"
                placeholder="Description"
                disabled={record.required}
              />
            </>
          </div>
        </div>
      </Drawer>
    );
}

export default Attachments;